export class ListItem {
  constructor(
    public id?: number,
    public abbreviation?: string,
    public title?: string,
    public description?: string,
    public parentLid?: number,
    public active?: boolean,
    public optionalField1?: string,
    public optionalField2?: string,
    public optionalField3?: string,
    public optionalField4?: string,
    public optionalField5?: string,
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/list-item.ts